<div class="sidenav-mobile" #sheetEl>
    <!-- Drag handle -->
    <div
        class="sidenav-mobile__handle-wrap"
        (pointerdown)="onDragStart($event)"
        (pointermove)="onDragMove($event)"
        (pointerup)="onDragEnd($event)"
        (pointercancel)="onDragEnd($event)"
        role="button"
        aria-label="Drag down to close"
        tabindex="0">
        <div class="sidenav-mobile__handle"></div>
    </div>

    <!-- ── L2 panel ── -->
    @if (activeItem()) {
        <div class="sidenav-mobile__panel sidenav-mobile__panel--l2">
            <div class="sidenav-mobile__header">
                <button matButton class="sidenav-mobile__back" (click)="goBack()">
                    <mat-icon class="riege-icon">chevron_left</mat-icon>
                    <span i18n="@@mobile-menu-back">Back</span>
                </button>
                <div class="sidenav-mobile__title">{{ activeItem()!.label }}</div>
            </div>

            <div class="sidenav-mobile__list">
                @for (child of activeItem()!.children; track child.id) {
                    <button matButton class="sidenav__link sidenav-mobile__item" (click)="navigateTo(child.route)">
                        <span class="sidenav__label sidenav-mobile__label">{{ child.label }}</span>
                    </button>
                }
            </div>
        </div>
    } @else {
        <!-- ── L1 panel ── -->
        <div class="sidenav-mobile__panel sidenav-mobile__panel--l1">
            <div class="sidenav-mobile__list sidenav-mobile__list--with-fab">
                @for (item of nav.navItems(); track item.id) {
                    <button
                        matButton
                        class="sidenav__link sidenav-mobile__item"
                        [class.sidenav-mobile__item--has-chevron]="item.children?.length"
                        (click)="item.children?.length ? openSubLevel(item) : navigateTo(item.route!)">
                        <mat-icon class="sidenav__icon riege-icon material-icons-outlined md-24" aria-hidden="true">
                            {{ item.icon }}
                        </mat-icon>
                        <span class="sidenav__label sidenav-mobile__label">{{ item.label }}</span>
                        <mat-icon
                            class="sidenav__chevron sidenav-mobile__chevron riege-icon"
                            iconPositionEnd
                            aria-hidden="true">
                            chevron_right
                        </mat-icon>
                    </button>
                }

                @if (nav.adminItem()) {
                    <button
                        matButton
                        class="sidenav__link sidenav-mobile__item sidenav-mobile__item--has-chevron"
                        (click)="openSubLevel(nav.adminItem()!)">
                        <mat-icon class="sidenav__icon riege-icon material-icons-outlined md-24" aria-hidden="true"
                            >settings</mat-icon
                        >
                        <span class="sidenav__label sidenav-mobile__label">{{ nav.adminItem()!.label }}</span>
                        <mat-icon
                            class="sidenav__chevron sidenav-mobile__chevron riege-icon"
                            iconPositionEnd
                            aria-hidden="true">
                            chevron_right
                        </mat-icon>
                    </button>
                }
            </div>
        </div>
    }

    <!-- X close FAB -->
    <button mat-fab class="sidenav-mobile__close-fab" (click)="dismiss()" aria-label="Close navigation">
        <mat-icon class="riege-icon">close</mat-icon>
    </button>
</div>
